import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

export const StudentsList = createAsyncThunk(
  'attendeceStduentsList/get',
  async (searchValues) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/students',
        method: 'POST',
        data: searchValues,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return { data: '', status: error?.response.status };
    }
  },
);

export const getDailyReports = createAsyncThunk(
  'getDailyReports/get',
  async (searchValues) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/dailyReport',
        method: 'GET',
        headers: searchValues,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return { data: error.response?.data, status: error.response.status };
    }
  },
);

export const getMonthlyReports = createAsyncThunk(
  'getmonthlyReports/get',
  async (searchValues) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/monthlyReport',
        method: 'GET',
        headers: searchValues,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return { data: error.response?.data, status: error.response.status };
    }
  },
);

export const getSelectedDateReports = createAsyncThunk(
  'getSelectedDateReports/get',
  async (searchValues) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/dateReport',
        method: 'GET',
        headers: searchValues,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return 'error';
    }
  },
);
export const SubmitAttendance = createAsyncThunk(
  'attendeceStduentsList Submission/post',
  async (finalData) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/mark',
        method: 'POST',
        data: finalData,
      });
      return { status: response?.status, data: response?.data };
    } catch (error) {
      console.log(error);
      return { status: error?.status, data: error.response?.data };
    }
  },
);

export const SendMessages = createAsyncThunk(
  'sendMessages/post',
  async (array, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/sendSMS',
        method: 'POST',
        data: array?.[0],
        headers: { attendanceDate: array?.[1] },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('SMSError');
    }
  },
);

export const postHoliday = createAsyncThunk('holiday/post', async (holiday) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/holiday-info/',
      method: 'POST',
      data: holiday,
    });
    console.log(response);
    return { data: response?.data, status: response.status };
  } catch (error) {
    console.log(error);
    return { data: error?.response?.data, status: error?.response.status };
  }
});
export const updateHoliday = createAsyncThunk(
  'holiday/update',
  async (holiday) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/holiday-info/',
        method: 'PUT',
        data: holiday,
      });
      return response.status;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
);

export const getHolidaysList = createAsyncThunk('holiday/get', async () => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/holiday-info/',
      method: 'GET',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return false;
  }
});
export const deleteHoliday = createAsyncThunk('holiday/delete', async (id) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/holiday-info/${id}`,
      method: 'DELETE',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return false;
  }
});
const AttendanceSlice = createSlice({
  name: 'attendance',
  initialState: {
    attendanceData: null,
    reportsDaily: null,
    reportsMonthly: null,
    classesInformation: null,
  },
  reducers: {
    SetClassesInfo: (state, action) => {
      state.classesInformation = action.payload;
    },
    UpdateSubmit: (state, action) => {
      state.attendanceData.absenties = action.payload;
      state.attendanceData.submit = true;
    },
    UpdateMonth: (state, action) => {
      state.reportsDaily.month = action.payload;
      state.reportsMonthly ? (state.reportsMonthly.month = action.payload) : '';
    },
  },
  extraReducers: (builder) => {
    builder
      //  attendance studetns Data
      .addCase(StudentsList.fulfilled, (state, action) => {
        state.attendanceData = { ...action.payload.data };
      })
      .addCase(getDailyReports.fulfilled, (state, action) => {
        state.reportsDaily = { ...action.payload.data };
      })
      .addCase(getMonthlyReports.fulfilled, (state, action) => {
        state.reportsMonthly = { ...action.payload.data };
      });
  },
});
export const { SetClassesInfo, UpdateSubmit, UpdateMonth } =
  AttendanceSlice.actions;
export default AttendanceSlice.reducer;
